<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import { useCurrency } from '@/composables/useCurrency'

const { currency } = useCurrency()
const { t } = useI18n()

const props = defineProps<{
  idgjold: Array<any> | null | undefined
}>()

// Vuetify 3: use title/key (not text/value)
const headers = computed(() => [
  { title: t('subpage_idgjold_table_header1'), key: 'idgjaldaManudur', sortable: false },
  { title: t('subpage_idgjold_table_header2'), key: 'greitt', sortable: false },
  { title: t('subpage_idgjold_table_header3'), key: 'sjodur', sortable: false },
  { title: t('subpage_idgjold_table_header4'), key: 'launaGreidandi', sortable: false },
  { title: t('subpage_idgjold_table_header5'), key: 'idgjald', align: "end" as const, sortable: false },
  { title: t('subpage_idgjold_table_header6'), key: 'motframlag', align: "end" as const, sortable: false },
  { title: t('subpage_idgjold_table_header7'), key: 'vextir', align: "end" as const, sortable: false },
  { title: t('subpage_idgjold_table_header8'), key: 'samtals', align: "end" as const, sortable: false },
])

function formatDateISO(iso?: string): string {
  if (!iso) return ''
  return moment(iso).format('DD.MM.YYYY')
}
function getGreitt(v: boolean): string {
  return v ? 'Greitt' : 'Ógreitt'
}
function getSjodur(code?: string): string {
  if (!code) return ''
  const c = code.charAt(0)
  if (c === 'X') return 'Gildi-séreignardeild'
  if (c === 'L') return 'Gildi-samtryggingardeild'
  return ''
}
</script>

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="props.idgjold ?? []"
      :loading="!props.idgjold"
      loading-text="Sæki gögn..."
      no-data-text="Engin gögn fundust"
      :items-per-page="10"
      :items-per-page-options="[5,10,25,50,-1]"
      :items-per-page-text="$t('perpage')"
      class="idgjold-table"
      hover
    >
      <!-- Columns using item slots must match header keys -->
      <template #item.greitt="{ item }">
        {{ getGreitt(item.greitt) }}
      </template>

      <!-- If you want to show a paid date, either add a header with key 'greidsluDagsetning'
           or keep it as a secondary line in launaGreidandi like the card example. -->
      <!-- <template #item.greidsluDagsetning="{ item }">
        {{ formatDateISO(item.dagsGreitt) }}
      </template> -->

      <template #item.sjodur="{ item }">
        {{ getSjodur(item.deildNr) }}
      </template>

      <template #item.idgjald="{ item }">
        {{ currency(item.idgjald) }} kr
      </template>

      <template #item.motframlag="{ item }">
        {{ currency(item.motframlag) }} kr
      </template>

      <template #item.samtals="{ item }">
        {{ currency(item.samtals) }} kr
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss">
input::placeholder{
  color: #909090 !important;
}
</style>
